import { handleActions } from 'redux-actions'
import { reject } from 'lodash/fp'
import { ILocation } from '../types/location'
import {
  SET_LOCATIONS,
  SET_CURRENT_LOCATION,
  UPDATE_LOCATION,
  REMOVE_LOCATION,
} from './locationsActions'

export interface ILocationsState {
  locations: ILocation[]
  currentLocation: ILocation | null
}

const initialState: ILocationsState = {
  locations: [],
  currentLocation: null,
}

export default handleActions<ILocationsState, any>(
  {
    [SET_LOCATIONS]: (state, { payload }) => ({
      ...state,
      locations: payload,
    }),
    [SET_CURRENT_LOCATION]: (state, { payload }) => ({
      ...state,
      currentLocation: payload,
    }),
    [UPDATE_LOCATION]: (state, { payload }) => {
      const index = state.locations.findIndex(
        (location) => location.id === payload.id,
      )
      if (index !== -1) {
        const updatedLocations = [...state.locations]
        updatedLocations[index] = payload
        return {
          ...state,
          locations: updatedLocations,
          currentLocation:
            state.currentLocation?.id === payload.id
              ? payload
              : state.currentLocation,
        }
      }
      return {
        ...state,
        locations: [...state.locations, payload],
      }
    },
    [REMOVE_LOCATION]: (state, { payload }) => ({
      ...state,
      locations: reject(
        (location: ILocation) => location.id === payload,
        state.locations,
      ),
      currentLocation:
        state.currentLocation?.id === payload ? null : state.currentLocation,
    }),
  },
  initialState,
)
